import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import {
  Module,
  getDefaultRouteNameFromModule,
  useDefaultRoutePath,
  useRoutePaths,
} from "utils";

export default (): null => {
  const { module } = useParams<{ module: Module }>();
  const navigate = useNavigate();
  const getRoutePath = useRoutePaths();
  const defaultRoutePath = useDefaultRoutePath();

  useEffect(() => {
    if (!module) {
      navigate(defaultRoutePath);
      return;
    }

    const routeName = getDefaultRouteNameFromModule(module);
    if (!routeName) {
      navigate(defaultRoutePath);
      return;
    }

    navigate(getRoutePath({ module, routeName }));
  }, []);

  return null;
};
